import React from 'react';
import { USER_TYPES } from '../constants/onboardingData';
import onboardingImg from "../../../assets/images/onboarding.jpeg"

/**
 * Step 1: Sélection du type d'utilisateur (Parent ou Élève)
 */
export default function Step1UserType({ onSelectType }) {
  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col pb-3">
      {/* Image header */}
      <div className="flex justify-center pt-8 pb-4">
        <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-white shadow-lg">
          <img
            src={onboardingImg}
            alt="Bienvenue"
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/placeholder.svg';
            }}
          />
        </div>
      </div>

      {/* Titre */}
      <div className="text-center px-6 pb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          Bienvenue sur GeniMi
        </h1>
        <p className="text-gray-500 text-lg">
          Qui utilise GeniMi aujourd'hui ?
        </p>
      </div>

      {/* Options */}
      <div className="flex-1 px-4 space-y-4">
        {USER_TYPES.map((type) => (
          <div
            key={type.id}
            onClick={() => onSelectType(type.id)}
            className={`bg-white rounded-2xl p-6 border-[3px] shadow-md 
                       hover:border-[#a7f3d0] hover:border-[4px] hover:scale-105
                       transition-all duration-200 cursor-pointer ${type.id === 'parent' ? "border-[#a7f3d0] hover:border-[#06cfad]" : "border-[#bfdbfe] hover:border-[#60a5fa]"} `}
          >
            <div className="flex flex-col items-center text-center gap-3">
              {/* Icône */}
              <div className={`w-20 h-20 rounded-full flex items-center justify-center ${type.id === 'parent' ? "bg-gradient-to-br from-emerald-400 to-teal-500" : "bg-gradient-to-br from-blue-400 to-cyan-500"}`}>
                {type.id === 'parent' ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                  className="lucide lucide-user-icon lucide-user text-white w-10 h-10">
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" 
                  stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-graduation-cap-icon lucide-graduation-cap w-10 h-10 text-white">
                    <path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/>
                    <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/>
                  </svg>
                )}
              </div>

              {/* Texte */}
              <div className="flex items-center gap-2">
                <span className="text-xl">{type.emoji}</span>
                <span className="font-bold text-lg text-gray-800">{type.label}</span>
              </div>
              
              <p className="text-gray-500 text-sm">{type.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
